/**
 * Adresa backend-a. Prazan string = isti domen kao i sajt (preporučeno: frontend se
 * servira iz Spring Boot-a ili je iza istog reverse proxy-ja).
 * Za razvoj koristi webpack dev server proxy (vidi webpack.config.cjs).
 */
export class Server {
    public static endpoint = '';
}
